import { useAllSelectedLocationIds, useIsAllLocationsSelected } from "components/DealersAndLocationsDropdown/hooks";
import { NavBarSearchKeys } from "components/NavBarSearch/queryKeys";
import { SEARCH_OPTION_TYPE, getFormattedAndSortedSearchResults } from "components/NavBarSearchAppointments/util";
import { useTypedQuery } from "hooks/useTypedQuery";
import { ApiInstance } from "utils/Api";

import type { Dealer } from "models";

const formatClaireSearchResults = getFormattedAndSortedSearchResults(SEARCH_OPTION_TYPE.Claire);

export const useClaireAppointmentSearchQuery = (searchTerm: string, selectedDealer?: Dealer | null) => {
  const { isAllLocationsSelected } = useIsAllLocationsSelected();
  const allSelectedLocationIds = useAllSelectedLocationIds();

  return useTypedQuery({
    queryKey: NavBarSearchKeys.claireAppointmentSearchResults,
    queryFn: async ({ endpoint, baseUrl }) =>
      (
        await ApiInstance.post(
          endpoint,
          {
            dealer_location_ids: isAllLocationsSelected ? allSelectedLocationIds : selectedDealer?.locations?.filter(l => l.active).map(l => l.id),
            limit: 20,
            page: 0,
            term: searchTerm
          },
          baseUrl
        )
      ).data.claire_appointments,
    enabled: false,
    select: formatClaireSearchResults
  });
};
